<template>
  <!-- <transition name="el-zoom-in-top"> -->
  <div class="content-wrapper">
    <!-- Main content -->
    <section class="content">
      <!-- Default box -->
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Create Publisher For Bidder</h3>
        </div>
        <div class="box-body">
          <h5>Enter Publisher's Name</h5>
          <!-- <p :class="{ 'control': true }"> -->
          <el-input
            class
            v-validate="'required'"
            data-vv-delay="1000"
            :class="{'input': true, 'is-danger': errors.has('name') }"
            name="name"
            type="text"
            placeholder="Publisher name"
            v-model="credentials.name"
          ></el-input>
          <span
            v-show="errors.has('name')"
            class="help is-danger"
            style="color:red"
          >{{ errors.first('name') }}</span>
          <hr />

          <!-- <h5>Enter E-Mail</h5>
          <!-- <p :class="{ 'control': true }"> -->
          <!--<el-input
            class
            v-validate="'required|email'"
            data-vv-delay="1000"
            :class="{'input': true, 'is-danger': errors.has('email') }"
            name="email"
            type="text"
            placeholder="Please enter email address"
            v-model="credentials.email"
          ></el-input>
          <span
            v-show="errors.has('email')"
            class="help is-danger"
            style="color:red"
          >{{ errors.first('email') }}</span>
          <hr />
          <span>enable AMP Setup</span>
          <el-switch
            v-model="credentials.amp_ss_enable"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
          <hr /> -->
          <!-- <h5>Enter Password</h5>
					
					<el-input class="" v-validate="'required'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('password') }" name="password" type="password" placeholder="Enter password for creator" v-model="credentials.password"></el-input>
					
					<hr>

					<h5>Re-Enter Password</h5>
					
					<el-input class="" v-validate="'required'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('repassword') }" name="repassword" type="password" placeholder="Reenter the password" v-model="credentials.repassword"></el-input>
					
          <hr>-->

          <!-- <h5>Enter Contact Number</h5> -->
          <!-- <p :class="{ 'control': true }"> -->
          <!-- <el-input class = "" v-validate="'required'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('number') }" name="number" type="number" placeholder="Contact Number" v-model="credentials.number"></el-input>
					<span v-show="errors.has('number')" class="help is-danger">{{ errors.first('number') }}</span>
          <hr>-->

          <button class="el-button el-button--success" @click="submit()" :disabled="!formValid">
            <i class="el-icon-plus el-icon-left"></i>
            Create Publisher
          </button>
          <!-- <button :disabled="!isactivateaccount" class="el-button el-button--success" @click="sentemail()">
						<i class="fa fa-envelope" aria-hidden="true"></i>
							Account Activate Mail
          </button>-->
          <router-link to="/admin/bidders/" class="el-button el-button--danger">Cancel</router-link>
        </div>
        <!-- /.box-body -->
      </div>
      <!-- /.box -->
    </section>
    <!-- /.content -->
  </div>
  <!-- </transition> -->
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      credentials: {
        name: ""
      },
      message: "",
      countryOptions: [],
      currenciesOptions: [],
      isactivateaccount: false,
    };
  },
  created: function () {
    console.log(this.$route.params);
    // this.$nextTick(function () {
    //   const self = this;
    //   axios
    //     .all([
    //       axios.get(BASE_URL + "v1/countries/"),
    //       axios.get(BASE_URL + "v1/currencies/"),
    //     ])
    //     .then(
    //       axios.spread(function (countries, currencies) {
    //         self.countryOptions = countries.data;
    //         self.currenciesOptions = currencies.data;
    //       })
    //     )
    //     .catch((error) => console.log(error));
    // });
  },
  methods: {
    submit() {
      console.log("calling create func");
        axios
          .post(BASE_URL + "bidder/v1/publishers/", {
            name: this.credentials.name
		   })
          .then((response) => {
            this.isactivateaccount = true;
            this.$notify({
              title: "Success",
              message: "Successfully created a new bidder publisher",
              type: "success",
            });

            setTimeout(() => {
              this.$router.push("/admin/bidders/create-domain");
            }, 1000);
          })
          .catch((error) => {
            this.$notify({
              title: "Warning",
              message: `Unable to create a new publisher`,
              type: "warning",
            });
          });

    },
  },
  computed: {
    formValid() {
      return this.credentials.name;
      // return  this.credentials.name && this.credentials.email && this.credentials.password && this.credentials.repassword;
    },
  },
};
</script>
<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.el-select {
  display: block;
}
.content-wrapper .content {
  padding-top: 95px;
}
button[disabled="disabled"],
button:disabled {
  background-color: rgba(200, 200, 200, 2.3);
  cursor: not-allowed;
  border-color: rgba(200, 200, 200, 2.3);
}
</style>



// WEBPACK FOOTER //
// Publisher.vue?5320bfd2